import { useLocation } from 'react-router-dom'

import { track } from '@amplitude/analytics-browser'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

const useHubspotEvents = ({ from }: { from: string }) => {
  const { pathname } = useLocation()
  const { company } = useCurrentSession()

  const eventPayload = {
    page_path: pathname,
    page_url: window.location.href,
    form_number_of_employees: company.numberEmployees,
    from: from,
  }

  const eventEmitter = (event: string) => {
    track(event, eventPayload)
  }

  return { eventEmitter, eventPayload }
}

export default useHubspotEvents
